import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '../page/common.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', './header.component.responsive.scss']
})
export class HeaderComponent implements OnInit {

  @Input() homeHeader: boolean = false;
  @Input() locationUrl: string = '';

  constructor(public cs: CommonService) { }

  ngOnInit() {
  }


  onLogoClick() {
    window.open("https://www.bticino.it/privati/", "_blank");
  }

}
